// Constants and data for loon pack presentation profiles
import { ASSETS } from './assets';
export const DEFAULT_PACK_PRESENTATION = {
    asset: ASSETS.loonSimple001,
};
export const PACK_PROFILES = [
    {
        packSize: 10,
        presentation: {
            asset: ASSETS.loonSimple010,
        },
        isBaseline: true,
    },
    {
        packSize: 25,
        presentation: {
            asset: ASSETS.loonSimple025,
            pricingBadge: 'Most Popular',
        },
    },
    {
        packSize: 50,
        presentation: {
            asset: ASSETS.loonSimple050,
        },
    },
    {
        packSize: 100,
        presentation: {
            asset: ASSETS.loonSimple100,
            pricingBadge: 'BEST VALUE',
        },
    },
];
export const BASELINE_PACK_SIZE = PACK_PROFILES.find((profile) => profile.isBaseline)?.packSize ?? 10;
//# sourceMappingURL=loonPacks.js.map